<template>
  <div class="sitemap-wrap py-3xl">
    <h2 class="px-2xl pb-2xl" v-text="localize('Sitemap')"></h2>
    <div class="sitemap px-2xl" v-if="parsedMap && parsedMap.length">
      <div
        v-for="category in parsedMap"
        :key="category.cid"
        :class="['sitemap--inner']"
      >
        <h4 class="font-rg upper">
          <router-link
            :to="category.path"
            v-text="category.title"
          ></router-link>
        </h4>

        <div
          v-if="category && category.children.length"
          class="sitemap--inner--subcategory pb-2xl"
        >
        
          <div
            class="pb-s font-rg"
            v-for="subcategory in category.children"
            :key="subcategory.cid"
          >
            <router-link
              :to="subcategory.path"
              v-text="subcategory.title"
            ></router-link>
            
            <div
              class="sitemap--inner--cat pl-s"
              v-if="subcategory.children.length"
            >
              <div
                class="pb-s"
                v-for="cat in subcategory.children"
                :key="cat.cid"
              >
                <router-link :key="cat.cid" :to="cat.path" class="text-gray-1">
                  <!--<i class="fal fa-chevron-right text-gray-3 mr-xs"></i>-->
                  -
                  <span v-text="cat.title" class="text-gray-7"></span>

                </router-link>
                
                <div
                  class="sitemap--inner--cat pl-s"
                  v-if="cat.children.length"
                >
                  <div
                    class="pb-s"
                    v-for="cat2 in cat.children"
                    :key="cat2.cid"
                  >
                    <router-link
                      :key="cat2.cid"
                      :to="cat2.path"
                      class="text-gray-8"
                    >
                      <!--<i class="fal fa-chevron-right text-gray-3 mr-xs"></i>-->
                      - 
                      <span v-text="cat2.title" class="text-gray-7"></span>
                    </router-link>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { fetchContent } from "@/utils";
export default {
  data() {
    return {};
  },
  async mounted() {
    this.resetPageLayout();
    this.initSitemap();
    this.setPageReady(true);
  },
  methods: {
    ...mapActions(["resetPageLayout", "setPageReady"]),
    async initSitemap() {
      let content = await fetchContent(
        "g",
        "sitemap",
        this,
        this.$store.state,
        this.$store.commit,
        "SET_SITEMAP",
        `https://api.mis-implants.com/api/sitemapdata`
      );
      console.log("sitemap content < ", content);
    }
  },
  computed: {
    ...mapState(["sitemap"]),
    parsedMap() {
      let items = this.sitemap;
      // console.log("items> ", items);
      if (items) {
        let itemsByHierarchy = items.filter(t => t.level == 0);
        _.each(itemsByHierarchy, item => {
          item.children = items.filter(t => t.pid == item.cid);
          _.each(item.children, item => {
            item.children = items.filter(t => t.pid == item.cid);
            _.each(item.children, item => {
              item.children = items.filter(t => t.pid == item.cid);
              _.each(item.children, item => {
                item.children = items.filter(t => t.pid == item.cid);
              });
            });
          });
        });
        // console.log("parsed menu >> ", itemsByHierarchy);
        return itemsByHierarchy;
      }
      return null;
    }
  }
};
</script>

<style lang="stylus" scoped>
.sitemap
  column-count 5
  +below(1400px)
    column-count 4
  +below(1200px)
    column-count 3
  +below(768px)
    column-count 2
  &--inner
    break-inside avoid
    page-break-inside avoid
    padding 0 30px 0 0

    a
      display block
      color gray_7
      font-size 14px
      margin-bottom 10px
      +desktop()
        &:hover
          color gray_9
    &--cat
      a
        color gray_5
        i
          font-size 80%
          margin-right 5px
    h4
      a
        color c_txt_blue !important
</style>
